module.exports = __webpack_public_path__ + "static/img/withdraw_message_icon2.9d1e2da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/withdraw_message_icon2.png
// module id = J+2p
// module chunks = 0